/* eslint-disable no-nested-ternary */
import { useNavigate, useParams } from 'react-router-dom';
import {
  Fragment, useEffect, useMemo, useState,
} from 'react';
import OrdersTableSkeleton from '../components/OrdersTableSkeleton';
import { useGetAllTicketsQuery, useGetShowtimesQuery } from '../store';
import TicketsTable from '../components/TicketsTable';
import CreateTicket from '../components/CreateTicket';
import CustomModal from '../components/atoms/CustomModal';
import AdminSectionTitle from '../components/AdminSectionTitle';
import useGetSelectedEvent from '../hooks/useGetSelectedEvent';
import LoadingLottie from '../components/atoms/LoadingLottie';
import ShowtimeTabs from '../components/ShowtimeTabs';
import Ticket from '../components/icons/Ticket';

const AdminTickets: React.FC = () => {
  const { event_id: eventId, business_id: businessId } = useParams();
  const [showTicketsModal, setShowTicketsModal] = useState(false);
  const [currentTab, setCurrentTab] = useState('');
  const [showCreateButton, setShowCreateButton] = useState(true);
  const navigate = useNavigate();
  const { event, eventLoading } = useGetSelectedEvent();
  const { data: showtimes } = useGetShowtimesQuery({ eventId: eventId || '', businessId: businessId || '' });

  useEffect(() => {
    if (event && event.has_showtimes && (!showtimes || showtimes.length === 0)) {
      setShowCreateButton(false);
    }
  }, [event]);

  if (!eventId || !businessId) {
    throw new Error('no event_id or business_id');
  }

  const { data: tickets, isFetching } = useGetAllTicketsQuery({
    businessId,
    eventId,
    publicSaleAvailable: false,
  });

  const sortedTickets = useMemo(() => (tickets
    ? [...tickets].sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime())
    : null), [tickets]);

  const handleSucessAddTicket = () => {
    setShowTicketsModal(false);
  };

  const handleAddTicket = () => {
    setShowTicketsModal(true);
  };

  if (eventLoading) {
    return <LoadingLottie />;
  }

  return (
    <div className="flex flex-col gap-8 w-full my-6">
      <AdminSectionTitle
        title="Eventos"
        subtitle={`${event?.name} - Entradas`}
        mainButtons={[{
          label: 'Funciones',
          onClick: () => navigate('../showtimes'),
          variant: 'secondary',
          image: '/sliders.svg',
          hidden: !event?.has_showtimes,
        }]}
      />
      <div className="glass-surface flex flex-col gap-8">
        {event?.has_showtimes && event && (
          <ShowtimeTabs
            event={event}
            onTabChange={setCurrentTab}
            selectedTab={currentTab}
          />
        )}
        {isFetching && <OrdersTableSkeleton />}{' '}
        {tickets && (
          <TicketsTable
            tickets={sortedTickets || []}
            eventId={eventId}
            businessId={businessId}
            showtimeId={currentTab || null}
            button={
              showCreateButton
                ? {
                  label: 'Crear nueva entrada',
                  onClick: handleAddTicket,
                  variant: 'secondary',
                  icon: <Ticket className='text-xl' />,
                }
                : undefined
            }
          />
        )}
      </div>
      <CustomModal
        onRequestClose={() => setShowTicketsModal(false)}
        isOpen={showTicketsModal}
        hideCancelButton={true}
      >
        <Fragment>
          <div className="flex flex-col justify-center items-center">
            <h1 className="text-2xl font-medium">Crear entrada</h1>
          </div>
          <CreateTicket showtimeId={currentTab || null} onSuccess={handleSucessAddTicket} onCancel={() => setShowTicketsModal(false)} />
        </Fragment>
      </CustomModal>
    </div>
  );
};

export default AdminTickets;
